module.exports = __webpack_public_path__ + "assets/img/1.f7cfdd3b.png";